import React , {useState} from 'react';

export default function Montant(props){ 
    const [open , switchOpen] = useState(false);
    const changeHandler=(e)=>{
        const value = parseInt(e.target.value) ;
        props.handler(value , props.name);
    };
    return <div className='montant-input-container'>
        <div
          onClick={(e)=>{switchOpen(!open)}}
          className='montant-label' 
          >{props.label} <i className={ open ? 'fa fa-chevron-down':'fa fa-chevron-up'}></i></div>
        {
            open ?
            <div className="montant-input">
                <label htmlFor={props.name}>{props.children}</label>
                <input 
                type="number"
                id={props.name}
                name={props.name}
                onChange={changeHandler}
                placeholder="Ex:15000"
                className="form-control"
                /><span className="euroSign">&euro;</span>
            </div>
            : ''
        }
    </div>;
}